import React from 'react';
import Stack, { contentStackSpacing } from '../../../v2BaseComponents/Stack';
import { APITypes, Dynamo, MedicalDataTypes } from '../../../../primary-record-types';
import AttachmentList from './AttachmentList';
import { UnloadedResourceCard } from '../../ResourceCard';
import { useNestedNavigation } from '../../../../utils/appNavigationNames';
import MarkdownDisplay from '../../../v2BaseComponents/MarkdownDisplay';

export type DetailsTabOwnProps = {
    note: APITypes.notesService.NoteDetails;
};

export type DetailsTabProps = DetailsTabOwnProps;

const entityTypeToResourceType: Record<Dynamo.ResourceNoteEntityType, MedicalDataTypes.PrimaryRecordResourceCategory> =
    {
        'condition-resource': 'condition',
        'medication-resource': 'medication',
        'allergy-resource': 'allergy',
        'visit-resource': 'visit',
        'imaging-resource': 'imaging',
        'vaccination-resource': 'vaccination',
        'procedure-resource': 'procedure',
        'lab-resource': 'lab',
    };

const DetailsTab: React.FC<DetailsTabProps> = (props) => {
    const { nestedProfileNavigation } = useNestedNavigation();

    const maybeRenderResourceCard = () => {
        if (
            (props.note.entityType === 'condition-resource' ||
                props.note.entityType === 'medication-resource' ||
                props.note.entityType === 'allergy-resource' ||
                props.note.entityType === 'visit-resource' ||
                props.note.entityType === 'imaging-resource' ||
                props.note.entityType === 'vaccination-resource' ||
                props.note.entityType === 'procedure-resource' ||
                props.note.entityType === 'lab-resource') &&
            props.note.medicalProfileId
        ) {
            const category = entityTypeToResourceType[props.note.entityType];
            const medicalProfileId = props.note.medicalProfileId;
            return (
                <UnloadedResourceCard
                    profileId={props.note.medicalProfileId}
                    category={entityTypeToResourceType[props.note.entityType]}
                    resourceId={props.note.entityId}
                    onPress={() => {
                        nestedProfileNavigation('data-details', {
                            profileId: medicalProfileId,
                            resourceId: props.note.entityId,
                            category: category,
                        });
                    }}
                />
            );
        } else {
            return null;
        }
    };

    return (
        <Stack vertical fullWidth space={contentStackSpacing}>
            <MarkdownDisplay>{props.note.markdownContent}</MarkdownDisplay>
            <AttachmentList note={props.note} />
            {maybeRenderResourceCard()}
        </Stack>
    );
};

export default React.memo(DetailsTab);
